import React from 'react';
import { useListConversations } from '../../api/conversations';
import { ConversationView } from '../ConversationView';
import { EmptyState } from '../../components/common/EmptyState';
import { LoadingState } from '../../components/common/LoadingState';

import { useTranslation } from 'react-i18next';

interface TaskExecutionViewProps {
  taskId: string;
  conversationId: string;
}

export const TaskExecutionView: React.FC<TaskExecutionViewProps> = ({
  taskId,
  conversationId,
}) => {
  const { t } = useTranslation('pleri/pages');
  const { data, isLoading } = useListConversations({
    source: 'task',
    sourceId: taskId,
    limit: 100, // Get enough to find the specific one
  });

  if (isLoading) {
    return <LoadingState text={t('loadingExecution')} />;
  }

  const execution = data?.conversations?.find(
    (conv) => conv.conversationId === conversationId,
  );

  if (!execution) {
    return (
      <EmptyState
        title={t('executionNotFound')}
        description={t('thisExecutionMayHaveBeenDeletedOr')}
      />
    );
  }

  // Check if execution is still running
  const isRunning =
    execution.status === 'running' || execution.status === 'thinking';

  return (
    <div className="space-y-4">
      <div className="rounded-lg border border-gray-200 bg-white dark:border-gray-700 dark:bg-gray-900">
        <ConversationView
          showMessageFromIndex={1}
          conversationId={execution.conversationId}
          headerText=""
          autoRefresh={isRunning}
          autoScrollToBottom={isRunning}
        />
      </div>
    </div>
  );
};
